<template xmlns="http://www.w3.org/1999/html">
  <div>
    <Breadcrumbs
      :breadcrumbs="[
      { title: this.$t(`menu.${serviceSlug}`), disabled: true},
      { title: $t('evohealth.leads-permissions.title'), disabled: true}
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">

      </div>
    </Breadcrumbs>

    <fade-transition
      :duration="400"
      mode="out-in">
      <div class="btn btn__floating">
        <va-popover
          :message="$t('users.save')"
          placement="left"
        >
          <va-button
            :disabled="!changesDetected || isLoading"
            @click.prevent="handleSaveChanges">
            <span class="is-bold" style="font-size: 17px">{{$t('users.save')}}</span>
          </va-button>

        </va-popover>
      </div>
    </fade-transition>

    <div class="row evollu-form">
      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{$t('facility.inputs.entity')}}:</label>
          <multiselect
            v-model="filters.entity"
            :options="entities"
            track-by="id"
            label="name"
            :custom-label="formatedEntityLabel"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('facility.inputs.entity')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="entities.length === 1">
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.entity"
                      @mousedown.prevent.stop="clearEntitiesMultiselect"></span>
            </template>
          </multiselect>
        </div>
      </div>
      <!--<div class="col-12 col-md-4" v-if="filters.entity">
        <div>
          <label class="form-label">{{$t('entities.roles.header_name')}}:</label>
          <multiselect
            v-model="filters.user"
            :options="users.length === 1 ? users[0] : users"
            track-by="id"
            label="name"
            :placeholder="$t('entities.roles.header_name')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="users.length === 1">
          </multiselect>
        </div>
      </div>-->
    </div>
    <div v-if="isLoading">
      <loading-placeholder/>
    </div>
    <div v-else>
      <div v-if="filters.entity && users.length > 0">
        <div class="warning-disclaimer" v-if="completeHealthGroups.length === 0">
          <h5>
            Não existem grupos de saúde para a entidade selecionada.
          </h5>
        </div>
        <div v-else class="table-container mt-4 ml-2">
            <div class="row header-row col-12">
              <div class="col-4 is-bold text-center"> <span style="color: #eeeeee">{{$t('entities.roles.header_name')}}</span>
              </div>
              <div class="col-4 is-bold text-center"> <span style="color: #eeeeee">{{$t('evohealth.leads-permissions.groups')}}</span>
              </div>
              <div class="col-3 is-bold text-center"> <span style="color: #eeeeee">{{$t('evohealth.leads-permissions.accessType')}}</span>
              </div>
              <div class="col-1 is-bold text-center"> <span style="color: #eeeeee">{{$t('clusters.labels.actions')}}</span>
              </div>
            </div>
            <div class="row permission-row col-12" style="background-color: #e7e7e7;">
              <div class="col-4 pt-3 pb-3 d-flex align-items-center">
                <multiselect
                  v-model="permissionToCreate.user"
                  :options="users"
                  track-by="id"
                  :custom-label="elem => `${elem.name} (${elem.email})`"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :placeholder="$t('entities.roles.header_name')"
                  :allow-empty="true"
                  :multiple="false"
                  :searchable="true">
                </multiselect>
              </div>
              <div class="col-4 pt-3 pb-3 d-flex align-items-center">
                <multiselect
                  ref="healthGroupsMultiselectCreate"
                  v-model="permissionToCreate.healthGroups"
                  :options="healthGroupOptions"
                  track-by="id"
                  :custom-label="elem => $t(`evohealth.healthGroups.${elem.name}`)"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :placeholder="$t('evohealth.leads-permissions.groups')"
                  :allow-empty="true"
                  :limit="3"
                  :multiple="true"
                  :searchable="true"
                  :close-on-select="false"
                  :disabled="permissionToCreate.user === null"
                  @input="(elem) => handleHealthGroupInputCreate(elem)">
                >
                  <template slot="option" slot-scope="{ option, index }">
                    <span :style="{ fontWeight: index === 0 ? 'bold' : 'normal' }">
                    {{ option.id === 'all' ? `-- ${$t('clusters.labels.select_all')} --` : option.id === 'none' ? `-- ${$t('clusters.labels.deselect_all')} --` : $t(`evohealth.healthGroups.${option.name}`) }}
                    </span>
                  </template>
                </multiselect>
              </div>
              <div class="col-3 pt-3 pb-3 d-flex align-items-center">
                <multiselect
                  v-model="permissionToCreate.accessType"
                  :options="accessTypes"
                  track-by="id"
                  label="label"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :placeholder="$t('evohealth.leads-permissions.accessType')"
                  :allow-empty="true"
                  :multiple="false"
                  :searchable="true"
                  :disabled="permissionToCreate.user === null || permissionToCreate.healthGroups.length === 0"
                >
                </multiselect>
              </div>
              <div class="col-1 pt-3 pb-3 d-flex align-items-center justify--center">
                <va-popover class="border-0" :message="$t('entities.add')" placement="top">
                  <i class="fa fa-plus-circle clickable" @click.prevent="addPermissionToCreate" :style="{ pointerEvents: !permissionToCreateIsCompleted ? 'none' : 'auto', opacity: !permissionToCreateIsCompleted ? 0.5 : 1 }"> </i>
                </va-popover>
              </div>
            </div>

            <div v-for="user in usersPermissionsData" class="row col-12 permission-row">
              <div class="col-4 pt-3 pb-3 d-flex align-items-center"> <span class="is-bold">{{user.name}}</span>&ensp;<span>({{user.email}})</span>
              </div>
              <div class="col-4 pt-3 pb-3 d-flex align-items-center">
                <multiselect
                  ref="healthGroupsMultiselectUpdate"
                  v-model="user.healthGroups"
                  :options="healthGroupOptions"
                  track-by="id"
                  label="name"
                  :custom-label="elem => $t(`evohealth.healthGroups.${elem.name}`)"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :placeholder="$t('evohealth.leads-permissions.groups')"
                  :close-on-select="false"
                  :allow-empty="true"
                  :limit="4"
                  :multiple="true"
                  :searchable="true"
                  @input="(elem) => handleHealthGroupInputUpdate(elem, user)">
                  <template slot="option" slot-scope="{ option, index }">
                    <span :style="{ fontWeight: index === 0 ? 'bold' : 'normal' }">
                    {{ option.id === 'all' ? `-- ${$t('clusters.labels.select_all')} --` : option.id === 'none' ? `-- ${$t('clusters.labels.deselect_all')} --` : $t(`evohealth.healthGroups.${option.name}`) }}
                    </span>
                  </template>
                </multiselect>
              </div>
              <div class="col-3 pt-3 pb-3 d-flex align-items-center">
                <multiselect
                  v-model="user.accessType"
                  :options="accessTypes"
                  track-by="id"
                  label="label"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :placeholder="$t('evohealth.leads-permissions.accessType')"
                  :allow-empty="true"
                  :multiple="false"
                  :searchable="true">
                </multiselect>
              </div>
              <div class="col-1 pt-3 pb-3 d-flex align-items-center justify--center">
                <va-popover class="border-0" :message="$t('buttons.delete')" placement="top">
                  <i class="fa fa-trash clickable" @click.prevent="handleDeletePermission(user)"> </i>
                </va-popover>
              </div>
            </div>


          </div>
      </div>
      <div v-else>
        <div class="no-data-disclaimer">
          <h5> {{ $t('please_select_filter_to_show_data') }} </h5>
        </div>
      </div>
    </div>




  </div>

</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import { EvohealthService } from '@/api/EvohealthService';
import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
import Multiselect from 'vue-multiselect';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import { AuthEvohealthService, UserService } from '@/api/AuthService';
import Vue from 'vue';
import { ClientTable } from 'vue-tables-2';
import _ from "lodash"
Vue.use(ClientTable, {}, false, 'bootstrap4')
import Slider from '@/components/common/Slider'
import FadeTransition from '@/components/common/transitions/FadeTransition.vue';
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin.vue';
import { isEqual, cloneDeep } from "lodash";
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder.vue';

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {
    LoadingPlaceholder,
    FadeTransition,
    Multiselect, RangeDatePicker,
    Breadcrumbs,
    ClientTable,
    Slider
  },
  mixins: [
    MultiselectLabelFormatter,
    IsFromEvolluMixin
  ],
  data() {
    return {
      filters: {
        entity: null,
        healthGroup: null,
        user: null,
      },
      isLoading: false,
      users: [],
      entities: [],
      healthGroups: [],
      completeHealthGroups: [],
      usersPermissionsData: [],
      originalUsersPermissionsData: [],
      accessTypes: [
        {
          id: 1,
          label: this.$t('users.permissions.read')
        },
        {
          id: 2,
          label: this.$t('users.permissions.write')
        }
      ],
      permissionToCreate: {
        user: null,
        healthGroups: [],
        accessType: null
      },
      healthGroupOptions: [],
    }
  },
  async created() {
    const leadsPermissionsInfoType = 105

    if(this.evohealthService) {
      const writeOrAdminPermissions = this.evohealthService.user_permissions.filter(perm => perm.info_type === leadsPermissionsInfoType && perm.access_type >= 2)
      const permitableEntitiesIds = writeOrAdminPermissions.map(elem => elem.entity_id)
      this.entities = permitableEntitiesIds.some (id => id === null) ? this.evohealthService.entities : this.evohealthService.entities.filter(ent => permitableEntitiesIds.includes(ent.id))

    }
  },
  computed: {
    changesDetected() {
      return !isEqual(this.originalUsersPermissionsData, this.usersPermissionsData)
    },
    evohealthService() {
      return this.$store.state.services.find(service => service.slug === this.serviceSlug)
    },
    permissionToCreateIsCompleted() {
      return this.permissionToCreate.user !== null && this.permissionToCreate.healthGroups.length > 0 && this.permissionToCreate.accessType !== null
    },
    hasManagementWritePermissions() {
      const leadsPermissionsInfoType = 105
      return this.evohealthService.user_permissions.some(perm => perm.info_type === leadsPermissionsInfoType && perm.access_type >= 2)
    }
  },
  methods: {
    handleHealthGroupInputOptions: function(user) {
      if(_.isEqual(user.healthGroups, this.completeHealthGroups)) {
        //Desselect All
        this.healthGroupOptions[0] = {id: 'none', name: 'deSelectAll'}
        console.log(this.healthGroupOptions)
      } else {
        //Select All
        this.healthGroupOptions[0] = {id: 'all', name: 'selectAll'}
      }
    },
    handleSaveChanges: async function() {
      try {
        this.isLoading = true
        const data = {
          entityId: this.filters.entity.id,
          permissions: []
        }
        this.usersPermissionsData.forEach(elem => {
          data.permissions.push({
            userId: elem.userId,
            evohealthHealthGroupIds: elem.healthGroups.map(hg => parseInt(hg.id)),
            accessType: elem.accessType.id
          })
        })
        const resp = await AuthEvohealthService.updateEvohealthLeadsPermissions(data)
        this.usersPermissionsData = this.parseUsersPermissionsData(resp)
        this.originalUsersPermissionsData = cloneDeep(this.usersPermissionsData)
      } catch (e) {
        console.log("Error: ")
        console.log(e)
        this.showToast(this.$t('profile.notifications.something_went_wrong'), this.$store.state.errorToastOptions)
      } finally {
        this.isLoading = false
      }
    },
    handleUserViewParsedData: async function() {
      if (this.selectedViewType === 0 && this.users.length > 0) {
        if (this.filters.user) {
          const filterUserId = this.filters.user.id
          const permissionsData = this.usersPermissionsData.filter(elem => elem.user_id === filterUserId)

          const writePermsIds = permissionsData
            .filter(perm => perm.access_type === 2)
            .map(elem => elem.evohealth_health_group_id);
          const writePerms = this.completeHealthGroups.filter(hg => writePermsIds.includes(parseInt(hg.id))) || [];

          const readPermsIds = [
            ...new Set([
              ...permissionsData.filter(perm => perm.access_type === 1).map(elem => elem.evohealth_health_group_id),
              ...writePermsIds,
            ])
          ];
          const readPerms = this.completeHealthGroups.filter(hg => readPermsIds.includes(parseInt(hg.id))) || [];

          this.userViewParsedData = [{
            userId: this.filters.user.id,
            entityId: this.filters.user.entity_id,
            user: this.filters.user.name,
            read: readPerms,
            write: writePerms
          }]
          this.userViewParsedDataOriginal = cloneDeep(this.userViewParsedData);
        } else {
          this.userViewParsedData = this.users.map(user => {
            const permissionsData = this.usersPermissionsData.filter(elem => elem.user_id === user.id);

            const writePermsIds = permissionsData
              .filter(perm => perm.access_type === 2)
              .map(elem => elem.evohealth_health_group_id);
            const writePerms = this.completeHealthGroups.filter(hg => writePermsIds.includes(parseInt(hg.id))) || [];

            const readPermsIds = [
              ...new Set([
                ...permissionsData.filter(perm => perm.access_type === 1).map(elem => elem.evohealth_health_group_id),
                ...writePermsIds, // Add write permissions to read
              ])
            ];
            const readPerms = this.completeHealthGroups.filter(hg => readPermsIds.includes(parseInt(hg.id))) || [];

            return {
              userId: user.id,
              entityId: user.entity_id,
              user: user.name,
              read: readPerms,
              write: writePerms
            };
          });
          this.userViewParsedDataOriginal = cloneDeep(this.userViewParsedData);
        }
      } else {
        this.userViewParsedDataOriginal = []
        this.userViewParsedData = []
      }
    },
    handleHealthGroupViewParsedData: function () {
      if(this.selectedViewType === 1 && this.healthGroups.length > 0) {
        //const consideredHealthGroupPerms = this.
        if(this.filters.healthGroup) {
          this.healthGroupViewParsedData = [{
            user: this.filters.user.name,
            read: false,
            write: false
          }]
        } else {
          this.healthGroupViewParsedData = this.users.map(user => {
            return {
              user: user.name,
              read: false,
              write: false
            }
          })
        }

      } else {
        this.healthGroupViewParsedData = []
      }
    },
    clearEntitiesMultiselect: function () {
      this.filters.entity = null
    },
    getUsersOfEntity: async function(entity) {
      try {
        const data = await AuthEvohealthService.getAllowedLeadsUsers(entity.id)
        if(data && data.length) {
          this.users = data
        }
      } catch(e) {
        console.log("Error getting users")
        console.log(e)
        this.showToast(this.$t('profile.notifications.something_went_wrong'), this.$store.state.errorToastOptions)
        this.isLoading = false
      } finally {

      }

    },
    async getEntityHealthGroups(entity) {
      this.healthGroups = await AuthEvohealthService.getEntityHealthGroups(entity.id)
      if(this.healthGroups.length > 0) {
        this.completeHealthGroups = await EvohealthService.getHealthGroupsByIds(this.healthGroups.map(elem => elem.evohealthHealthGroupId))
        this.healthGroupOptions = [
          { id: 'all', name: 'selectAll' },
          ...this.completeHealthGroups
        ];
      }
    },
    parseUsersPermissionsData(data) {
      if(this.completeHealthGroups.length === 0 || data.length === 0) return []

      data.forEach(elem => {
        elem.healthGroups = this.completeHealthGroups.filter(hg => elem.healthGroups.includes(parseInt(hg.id)))
        elem.accessType = this.accessTypes.find(at => at.id === elem.accessType)
      })

      return data
    },
    handleHealthGroupInputCreate(elem) {

      if (elem.some(e => e.id === "all")) {
        this.permissionToCreate.healthGroups = this.completeHealthGroups
        this.healthGroupOptions = [
          { id: 'none', name: 'deSelectAll' },
          ...this.completeHealthGroups
        ]
        this.$refs.healthGroupsMultiselectCreate.deactivate()
      } else if (elem.some(e => e.id === "none")) {
        this.permissionToCreate.healthGroups = []
        this.healthGroupOptions = [
          { id: 'all', name: 'selectAll' },
          ...this.completeHealthGroups
        ]
        this.$refs.healthGroupsMultiselectCreate.deactivate()
      }
    },
    handleHealthGroupInputUpdate(elem, user) {
      if(user.healthGroups && user.healthGroups.length === 0) {
        //user.accessType = null
        this.usersPermissionsData = this.usersPermissionsData.filter(u => u !== user);
      }

      if(elem.some(e => e.id==="all")) {
        user.healthGroups = this.completeHealthGroups
        this.healthGroupOptions = [
          { id: 'none', name: 'deSelectAll' },
          ...this.completeHealthGroups
        ]
        this.$refs.healthGroupsMultiselectUpdate.deactivate()
      } else if (elem.some(e => e.id==="none")) {
        user.healthGroups = []
        this.healthGroupOptions = [
          { id: 'all', name: 'selectAll' },
          ...this.completeHealthGroups
        ]
        this.$refs.healthGroupsMultiselectUpdate.deactivate()
      }
    },
    handleDeletePermission(user) {
      this.usersPermissionsData = this.usersPermissionsData.filter(u => u !== user)
    },
    addPermissionToCreate() {
      if(this.permissionToCreateIsCompleted) {
        this.usersPermissionsData.push({
          userId: this.permissionToCreate.user.id,
          accessType: this.permissionToCreate.accessType,
          email: this.permissionToCreate.user.email,
          healthGroups: this.permissionToCreate.healthGroups,
          name: this.permissionToCreate.user.name
        })
        this.permissionToCreate = {
          user: null,
          healthGroups: [],
          accessType: null
        }

        this.usersPermissionsData.sort((a,b) => a.name.localeCompare(b.name))
      }
    }
  },
  watch: {
    'filters.entity': async function(val) {
      if (val) {
        this.isLoading = true
        await this.getUsersOfEntity(val)
        await this.getEntityHealthGroups(val)
        const data = await AuthEvohealthService.getLeadsPermissions(this.filters.entity.id)
        this.usersPermissionsData = this.parseUsersPermissionsData(data)
        this.originalUsersPermissionsData = cloneDeep(this.usersPermissionsData)
        this.isLoading = false
        //await this.handleUserViewParsedData()
      } else {
        this.users = []
        this.usersPermissionsData = []
        this.originalUsersPermissionsData = []
      }
    },
    'filters.user': async function(val) {
      //await this.handleUserViewParsedData()
    },
    'permissionToCreate.user': async function(val) {
      if(!val) {
        this.permissionToCreate.healthGroups = []
        this.permissionToCreate.accessType = null
      }
    }
  }
};
</script>

<style scoped lang="scss">
.table-user-view {
  margin-top: 20px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border: 1px solid #e5e5e5;
}
.header-row {
  background-color: #29C4AA;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  height: 60px;
  display: flex;
  align-items: center;

}

.user-view-row {
  border-bottom: 1px solid #e5e5e5;
  height: 60px;
  align-content: center;
}

.colored-row-bg {
  background-color: #e5e5e5;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

.no-data-disclaimer {
  width: 100%;
  margin-top: 20px;
  border-radius: 12px;
  background-color: rgb(246, 236, 221);
  height: 60px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  h5 {
    color: #878787;
  }
}

.warning-disclaimer {
  width: 100%;
  margin-top: 20px;
  border-radius: 12px;
  background-color: rgb(245, 214, 195);
  height: 60px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  h5 {
    color: #878787;
  }
}

.permission-row {
  padding: 0!important;
  min-height: 50px;
  div {
    border: 1px solid #e5e5e5;
  }
}

.multiselect .multiselect__tags {
  width: 100% !important;
}


</style>
